import React, { memo } from "react";
import ProductGiftLevel from "../ProductGiftLevel";
import useStyles from "./styles";

import { Grid } from "@material-ui/core";
import { formatCash } from "config/constant";

const LevelPromotion = props => {
	const classes = useStyles();
	const { products, isAllProduct, type } = props;

	const renderTextCondition = (isAllProduct, products, type) => {
		if (type === "GIFT") {
			return isAllProduct ? (
				<React.Fragment>
					Mua từ{" "}
					<span
						style={{ textTransform: "lowercase", color: "#F84F06" }}
					>
						{products?.totalQuantity ||
							formatCash(products?.totalAmount)}{" "}
						{products?.totalQuantity ? products?.unit || "lẻ" : "đ"}
					</span>{" "}
					trong sản phẩm áp dụng.
				</React.Fragment>
			) : (
				<React.Fragment>
					Mua từ{" "}
					{products?.productConditions?.map(
						(productCondition, index) => {
							return (
								<React.Fragment key={index}>
									<span>{index > 0 ? " và" : ""}</span>
									<span style={{ color: "#F84F06" }}>
										{" "}
										{productCondition?.quantity ||
											formatCash(
												productCondition?.amount
											)}{" "}
										<span
											style={{
												textTransform: "lowercase"
											}}
										>
											{productCondition?.unit || "đ"}
										</span>{" "}
										{productCondition?.name}
									</span>
								</React.Fragment>
							);
						}
					)}{" "}
					trong sản phẩm áp dụng.
				</React.Fragment>
			);
		}
		if (type === "DISCOUNT") {
			const isConditionAmount = products?.productConditions?.every(
				product => !!product?.amount
			);
			return isAllProduct ? (
				<React.Fragment>
					Mua từ{" "}
					<span
						style={{ textTransform: "lowercase", color: "#F84F06" }}
					>
						{products?.totalQuantity ||
							formatCash(products?.totalAmount)}{" "}
						{products?.unit || "đ"}{" "}
					</span>{" "}
					trong sản phẩm áp dụng.
				</React.Fragment>
			) : (
				<React.Fragment>
					{isConditionAmount ? (
						<React.Fragment>
							Mua đơn hàng có giá trị ít nhất từ{" "}
							{products?.productConditions?.map(
								(productCondition, index) => {
									return (
										<React.Fragment key={index}>
											<span>
												{index > 0 ? " và" : ""}
											</span>
											<span style={{ color: "#F84F06" }}>
												{" "}
												{formatCash(
													productCondition?.amount
												)}{" "}
												đ với sản phẩm{" "}
												{productCondition?.name}
											</span>
										</React.Fragment>
									);
								}
							)}{" "}
							trong sản phẩm áp dụng.
						</React.Fragment>
					) : (
						<React.Fragment>
							Mua từ{" "}
							{products?.productConditions?.map(
								(productCondition, index) => {
									return (
										<React.Fragment key={index}>
											<span>
												{index > 0 ? " và" : ""}
											</span>
											<span style={{ color: "#F84F06" }}>
												{" "}
												{productCondition?.quantity ||
													formatCash(
														productCondition?.amount
													)}{" "}
												<span
													style={{
														textTransform:
															"lowercase"
													}}
												>
													{productCondition?.unit ||
														"đ"}
												</span>{" "}
												{productCondition?.name}
											</span>
										</React.Fragment>
									);
								}
							)}{" "}
							trong sản phẩm áp dụng.
						</React.Fragment>
					)}
				</React.Fragment>
			);
		}
	};

	const renderProductCondition = (products, type) => {
		if (type === "GIFT") {
			return (
				<React.Fragment>
					{products?.promotionGifts?.map(productPromotion => {
						return (
							<ProductGiftLevel
								key={productPromotion?.giftProductGroupId}
								product={productPromotion?.products[0]}
								products={productPromotion}
								quantity={productPromotion?.quantity}
							/>
						);
					})}
				</React.Fragment>
			);
		}
		if (type === "DISCOUNT") {
			return (
				<Grid classes={{ root: classes.discount }}>
					Chiết khấu trực tiếp{" "}
					<span style={{ color: "#F84F06" }}>
						{products?.discount}%
					</span>
				</Grid>
			);
		}
	};

	return (
		<Grid classes={{ root: classes.root }}>
			<Grid classes={{ root: classes.level }}>
				Hạng mức {products?.level || 0}
			</Grid>
			<Grid classes={{ root: classes.title }}>Điều kiện</Grid>
			<Grid classes={{ root: classes.text }}>
				{renderTextCondition(isAllProduct, products, type)}
			</Grid>
			<Grid classes={{ root: classes.title }}>Bạn sẽ được tặng</Grid>
			{renderProductCondition(products, type)}
		</Grid>
	);
};

export default memo(LevelPromotion);
